{
    "OnavailablestateLabel": "No estado Disponível em:",
    "OnbusystateLabel": "Em estado ocupado sobre:",
    "OnnaordndstateLabel": "Em estado N\/A ou DND (Não Incomodar) Sobre:",
    "OnwrapupLabel": "No estado de Wrap-up:",
    "OnavailablestateEnabledHiddenlabel": "A Definição Em Estado Disponível Excedido está Ativada?",
    "OnbusystateEnabledHiddenlabel": "A Definição Em Estado Ocupado Excedido está Ativada?",
    "OnnaordndstateEnabledHiddenlabel": "A Definição Em Estado N\/A ou DND (Não Incomodar) Excedido está Ativada?",
    "OnwrapupEnabledHiddenlabel": "A Definição Em Estado de Wrap-up Excedido está Ativada?",
    "OnavailablestatePlaceholder": "30s",
    "OnbusystatePlaceholder": "5m 0s",
    "OnnaordndstatePlaceholder": "3m 0s",
    "OnwrapupPlaceholder": "3m 0s",
    "ACDStateThresholds_SectionHeader": "Limites de estado de ACD",
    "ACDStateThresholds_SectionPara": "É possível ativar alarmes quando os agentes permanecem num determinado estado ACD durante demasiado tempo. Selecione os estados ACD que irão ativar um alarme abaixo e, em seguida, selecione a duração de ativação necessária.",
    "NAME": "ACDStateThresholds"
}